'use clinet';

import { setFormModal } from '@/lib/RTK/features/AdmissionSlice';
import { useAppDispatch, useAppSelector } from '@/lib/RTK/hooks';
import { rulesDataModal } from '@/constant';
import * as Dialog from '@radix-ui/react-dialog';
import { useCallback, useState } from 'react';
import { TypeEnabaleBtn } from './types/AdmissionType';
import { LoadingButton } from '@/components/ui/loading-button';
import { GoAlertFill } from 'react-icons/go';
import { CiCircleRemove } from 'react-icons/ci';
import { Button } from '@/components/ui/button';
import { FaAngleLeft } from 'react-icons/fa';

export default function BtnSendFormModal(
    props: Omit<TypeEnabaleBtn, 'docid' | 'clinic'>,
) {
    const {
        enableSubmit,
        handleResetPosition,
        docname,
        per_visit,
        textBtn,
        coordination,
        useLab_imaging,
    } = props;

    const [acceptModal, setAccentModal] = useState(false);
    const dispatch = useAppDispatch();
    const token = useAppSelector((state) => state.auth_token_slice.token);

    const updateModalPage = useCallback(() => {
        if (!token || token === 'undefined') {
            dispatch(setFormModal('formlogin'));
        } else {
            dispatch(setFormModal('formturn'));
        }
    }, [token]);

    return (
        <Dialog.Root
            onOpenChange={(open) => {
                if (!open) {
                    handleResetPosition();
                    setAccentModal(false);
                }
            }}
        >
            <Dialog.Trigger disabled={!enableSubmit} asChild>
                <Button className="smp:!w-max w-full !bg-blue !mt-4 hover:!bg-blue text-white !h-10 items-center smp:!rounded-2xl hover:!opacity-75 transition-opacity text-sm smp:!text-base !flex gap-1 !px-8">
                    {textBtn ? 'درخواست نوبت' : 'ادامه'}
                    <FaAngleLeft className="text-white" />
                </Button>
            </Dialog.Trigger>
            <Dialog.Portal>
                <Dialog.Overlay className="fixed inset-0 bg-[#0000002b] opacity-100  z-10" />
                <Dialog.Content className="data-[state=open]:animate-contentShow z-50 fixed top-[50%] left-[50%] max-h-[85vh] w-[90vw] max-w-[540px] translate-x-[-50%] translate-y-[-50%] !rounded-2xl bg-white p-[25px] shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none">
                    <Dialog.Title className=" pb-3 text-[17px] flex items-center gap-3 text-red-600 font-bold">
                        <GoAlertFill className="i_f " />
                        توجه
                    </Dialog.Title>
                    <Dialog.Description className=" my-2 lg:my-5 text-[15px] leading-normal">
                        کاربر گرامی:
                    </Dialog.Description>
                    <fieldset className="mb-[15px] flex items-center gap-5">
                        <ul className="list-disc mr-4 flex_col gap-3 overflow-hidden">
                            {rulesDataModal(
                                docname || 'نام',
                                per_visit || '',
                                coordination || 'دارد',
                                useLab_imaging || false,
                            ).map(
                                (i) =>
                                    i && (
                                        <li
                                            className={`${
                                                i?.active ? 'text-red-700' : ''
                                            } text-sm`}
                                            key={i?.id}
                                        >
                                            {i?.label}
                                        </li>
                                    ),
                            )}
                        </ul>
                    </fieldset>
                    <fieldset
                        className="flex gap-2 w-fit items-center select-none"
                        onClick={() => setAccentModal(!acceptModal)}
                    >
                        <input
                            type="checkbox"
                            className="w-5 h-5 accent-blue"
                            checked={acceptModal}
                            onChange={() => {}}
                        />
                        تایید می کنم
                    </fieldset>
                    <div className="mt-[25px] flex justify-end">
                        <Dialog.Close asChild>
                            <LoadingButton
                                disabled={!acceptModal}
                                onClick={updateModalPage}
                                className="bg-blue text-white hover:bg-blue"
                            >
                                ثبت نوبت
                            </LoadingButton>
                        </Dialog.Close>
                    </div>
                    <Dialog.Close asChild>
                        <button
                            className="font-bold text-2xl hover:bg-violet4 focus:shadow-violet7 absolute top-[10px] left-[10px] inline-flex h-[25px] w-[25px] appearance-none items-center justify-center rounded-full focus:shadow-[0_0_0_2px] focus:outline-none"
                            aria-label="Close"
                        >
                            <CiCircleRemove />
                        </button>
                    </Dialog.Close>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
}
